import React, { Component } from 'react';
import { Popup } from '../common';

class YearRange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFrom: '',
      dateTo: '',
    };
  }

  onYearChanged(value, field) {
    // console.log('onYearChanged', value);
    if (field === 'from') {
      this.setState({ dateFrom: value });
      this.props.onChangeHandler([value, this.state.dateTo]);
    } else {
      this.setState({ dateTo: value });
      this.props.onChangeHandler([this.state.dateFrom, value]);
    }
  }

  // generateYears() {
  //   const date = new Date();
  //   const currentYear = date.getFullYear();
  //   const totalYears = currentYear - 1999;
  //   const years = Array(totalYears)
  //     .fill()
  //     .map((_, i) => 2000 + i);

  //   return years;
  // }

  generateYears() {
    const date = new Date();
    const currentYear = date.getFullYear();
    const startYear = 1990;
    const totalYears = currentYear - startYear + 1;
    const years = Array(totalYears)
      .fill()
      .map((_, i) => startYear + i);

    return years;
  }

  render() {
    return (
      <div
        className={`field-wrapper ${this.props.labelPositionTop && 'label-on-top'
          }`}>
        <label className="field-label">
          {this.props.label}{' '}
          {this.props.information && (
            <Popup
              trigger={() => (
                <img
                  style={{ marginLeft: '10px' }}
                  alt=""
                  src={require('./../../images/icon-tooltip.png')}
                  width="18px"
                  height="18px"
                />
              )}
              position="top center"
              on={['hover']}
              closeOnDocumentClick>
              <span>{this.props.information}</span>
            </Popup>
          )}
        </label>
        <div className="field">
          <div className="sub-fields hlp-flex flex-aic flex-jcsb">
            <label>From</label>
            <select
              onChange={(event) =>
                this.onYearChanged(event.target.value, 'from')
              }
              value={this.props.value[0]}>
              <option value="" />
              {this.generateYears().map((option, key) => (
                <option key={key} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <label>To</label>
            <select
              onChange={(event) => this.onYearChanged(event.target.value, 'to')}
              value={this.props.value[1]}>
              <option value="" />
              {this.generateYears().map((option, key) => (
                <option key={key} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    );
  }
}

export { YearRange };
